import { render, staticRenderFns } from "./UserCardSkeleton.vue?vue&type=template&id=74ca1e10"
import script from "./UserCardSkeleton.vue?vue&type=script&lang=js"
export * from "./UserCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports